import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import { IconButton, Stack, Tooltip, Typography } from "@mui/material";
import type { GridCellParams, GridColDef } from "@mui/x-data-grid-premium";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis.tsx";
import { nameof } from "@entrilia/shared/utilities/typeHelper.ts";
import type { UsedByReport, UsedByReportSource } from "../../../../../../../../../api/types/svTypes.ts";
import {
  getEditApiReportUrl,
  getEditReportTemplateUrl,
  getEditUiReportUrl,
} from "../../../../../../report-lists/reports/utilities/editReportUrl.ts";

export const columns: GridColDef<UsedByReport>[] = [
  {
    field: nameof<UsedByReport>("reportName"),
    headerName: "Name",
    flex: 1,
    resizable: false,
    renderCell: ({ value }: GridCellParams<UsedByReport, string>) => (
      <TypographyTooltipEllipsis tooltipProps={{ disableInteractive: true }} text={value ?? ""} />
    ),
  },
  {
    field: nameof<UsedByReport>("source"),
    resizable: false,
    headerName: "Source",
    flex: 0.5,
    renderCell: ({ value, row }: GridCellParams<UsedByReport, UsedByReportSource>) => (
      <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center", width: "100%" }}>
        <Typography noWrap>{value}</Typography>
        <Tooltip title={"Open in New Window"} arrow disableInteractive>
          <IconButton
            href={value ? buildHref(value, row.clientCode, row.organization, row.id) : ""}
            target="_blank"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <OpenInNewRoundedIcon />
          </IconButton>
        </Tooltip>
      </Stack>
    ),
  },
];

const buildHref = (source: UsedByReportSource, clientCode: string, organization: string, reportId: string) => {
  if (source === "Report") {
    return getEditUiReportUrl(clientCode, reportId);
  }

  if (source === "API Analytics") {
    return getEditApiReportUrl(clientCode, reportId);
  }

  if (source === "Template") {
    return getEditReportTemplateUrl(organization, clientCode, reportId);
  }

  return "";
};
